import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {Zona, ZonaPayload, ZonasFilters, ZonasPaginatedResponse} from './zonas.interface';

@Injectable({
  providedIn: 'root'
})
export class ZonasService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(params?: ZonasFilters): Observable<GenericHttpResponse<ZonasPaginatedResponse>> {
    const url = this.httpCommonService.makeUrl('/ubic/zonas', params);
    return this.http.get<GenericHttpResponse<ZonasPaginatedResponse>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<Zona>> {
    const url = this.httpCommonService.makeUrl(`/ubic/zonas/${id}`);
    return this.http.get<GenericHttpResponse<Zona>>(url);
  }

  store(body: ZonaPayload): Observable<GenericHttpResponse<Zona>> {
    const url = this.httpCommonService.makeUrl('/ubic/zonas');
    return this.http.post<GenericHttpResponse<Zona>>(url, body);
  }

  update(id: number, body: Partial<ZonaPayload>): Observable<GenericHttpResponse<Zona>> {
    const url = this.httpCommonService.makeUrl(`/ubic/zonas/${id}`);
    return this.http.put<GenericHttpResponse<Zona>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<void>> {
    const url = this.httpCommonService.makeUrl(`/ubic/zonas/${id}`);
    return this.http.delete<GenericHttpResponse<void>>(url);
  }
}
